<template>
  <div class="mealsDetails">
    <div>
      <img
        style="width: 100%; height: 300px"
        :src="detailsData.headUrl"
        alt=""
      />
    </div>
    <van-row class="content">
      <van-col span="24">
        <span class="title">{{ detailsData.name }}</span>
      </van-col>
      <van-col span="24" style="padding-top: 5px">
        <span class="price">￥{{ detailsData.price }}</span>
        <span class="unitName"> / {{ detailsData.unitName }}</span>
      </van-col>
      <van-col span="24" style="padding: 5px 0">
        <span class="unitName">菜品描述：</span>
        <span>{{ detailsData.remark }}</span>
      </van-col>
    </van-row>
    <!-- 购物车bar -->
    <ShoppingCart
      @cartEmpty="cartEmpty"
      :shoppingData="shoppingData"
      :tip="true"
    ></ShoppingCart>
  </div>
</template>
<script setup>
import { reactive, toRefs } from "vue";
import { useRoute, useRouter } from "vue-router";
import { mealsDetails } from "@/api/orderingFood/orderingFood";
import ShoppingCart from "@/components/orderingFood/shoppingCart.vue";
const router = useRouter();
const route = useRoute();
const state = reactive({
  dishId: route.query.id,
  detailsData: {},
  shoppingData: {
    selectList: [],
    shoppingCarNum: 0,
    mealTypeName: "",
    mealTypeType: "",
    orgId: route.query.orgId,
    canteenId: route.query.canteenId,
    orgAddress: route.query.orgAddress,
    orderType: 2,
  },
});
const { detailsData, shoppingData } = toRefs(state);
const queryDetails = () => {
  mealsDetails({ dishId: state.dishId }).then((v) => {
    const { data } = v;
    state.detailsData = data;
    console.log(data);
  });
};
queryDetails();
</script>
<style lang="scss" scoped>
.mealsDetails {
  .content {
    padding: 10px;
    .title {
      font-size: 17px;
      font-weight: bold;
    }
    .price {
      color: #1e98d7;
    }
    .unitName {
      color: #aaaaaa;
      vertical-align: bottom;
      padding: 5px 0;
    }
  }
}
</style>
